module.exports = "<atn-layout></atn-layout>\r\n"


//////////////////
// WEBPACK FOOTER
// ./apps/nox/src/app/app.component.html
// module id = ./apps/nox/src/app/app.component.html
// module chunks = main